import { LicenseInfo } from '@mui/x-license';
import {
  StylesProvider,
} from "@material-ui/core/styles";

import { DeepPartial } from "../types";

import "./global.css";

import { AppThemeProvider } from "./theme";
import { AppThemeProperties } from './types'

LicenseInfo.setLicenseKey('d3138f71a44b8f67f6e26b364bc76d55Tz0xMzI5MTQsRT0xODIwNzkzNTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=');

interface StyleProvidersProps {
  children: React.ReactNode;
  renderCssBaseline?: boolean;
  theme?: DeepPartial<AppThemeProperties>;
}

/**
 * Should wrap the application.
 */
export function StyleProviders({
  children,
  theme,
  renderCssBaseline
}: StyleProvidersProps): JSX.Element {
  return <StylesProvider injectFirst>
    <AppThemeProvider theme={theme ?? {}} renderCssBaseline={renderCssBaseline}>
      {children}
    </AppThemeProvider>
  </StylesProvider>
}
